import { useEffect, useState } from 'react';
import { GridFontSettings } from '../../../../libs/ui-settings-manager/interfaces';
import { DEFAULT_GRID_FONT_SETTINGS, UISettingsManager } from '../../../../libs/ui-settings-manager/UISettingsManager';

export const useGridFontSettings = (): GridFontSettings => {
    const [font, setFont] = useState<GridFontSettings>(
        () => UISettingsManager.getSettings().grids?.font ?? DEFAULT_GRID_FONT_SETTINGS
    );

    useEffect(() => {
        const handler = (e: Event) => {
            const detail = (e as CustomEvent).detail;
            setFont(detail?.grids?.font ?? DEFAULT_GRID_FONT_SETTINGS);
        };
        window.addEventListener('uiSettingsChanged', handler);
        return () => window.removeEventListener('uiSettingsChanged', handler);
    }, []);

    return font;
};